<template>
  <div>
    <div class="flex items-center">
      <h4
        class="flex-shrink-0 pr-4 font-bebas tracking-wider text-lg leading-5 tracking-wider uppercase text-gray-600"
      >
        Software
      </h4>
      <div class="flex-1 border-t-2 border-green" />
    </div>
    <div class="flex relative z-0 overflow-hidden mt-4">
      <div :logo="logo" v-for="(logo, idx) in productLogos" :key="idx">
        <img :src="logo" alt="" class="w-24 mr-4" />
      </div>
    </div>
  </div>
</template>

<script>
import sanityImageBuilder from "../utils/sanityImageBuilder";

export default {
  name: "SessionCompatibilityBlock",
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  computed: {
    productLogos() {
      let logos = [];
      if ("productCompatibility" in this.session) {
        this.session.productCompatibility.forEach(product => {
          logos.push(
            sanityImageBuilder
              .image(product.logo)
              .width(200)
              .url()
          );
        });
      }
      return logos;
    }
  }
};
</script>

<style scoped></style>
